export const isLoggedIn = () => !!localStorage.getItem('isLoggedIn');

export const numberToLocale = (n: number) => {
  if (!n || typeof n !== 'number') return 0;
  return n.toLocaleString();
};
